import { useState } from "react";
import debouce from "lodash/debounce";

import { isBrowser } from "../constants";
import { useEventListener } from "../useEventListener";

interface IWindowDimensions {
  width: number;
  height: number;
}

const useWindowDimensions = (): IWindowDimensions => {
  const [windowDimensions, setWindowDimensions] = useState<IWindowDimensions>({
    width: isBrowser ? window.innerWidth : 1024,
    height: isBrowser ? window.innerHeight : 1024,
  });

  const handleResize = debouce(() => {
    setWindowDimensions({
      width: isBrowser ? window.innerWidth : 1024,
      height: isBrowser ? window.innerHeight : 1024,
    });
  }, 200);

  useEventListener("resize", handleResize);

  return windowDimensions;
};

export default useWindowDimensions;
